import { httpGet } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { AppUser } from '../types/AppUser';

const getUsers = async (query): Promise<PaginatedResult<AppUser>> => await httpGet(`api/autocomplete/user/${query}`);

export { getUsers };
